import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class EmpresasService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
      this.authorization += session.idToken;
    }

    ngOnInit(){}
    listar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/empresas/listar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
  
    }

    listarTodas(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/empresas/listarTodas",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarDocumentosAdjuntos(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listarDocumentosAdjuntos",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarDocumentos(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listarDocumentos",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarCamposDisponibles(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);      
      formData.append('accessToken', this.session.currentUser.accessToken);
      this.http
      .post(
        Constants.API_BASE + "/trabajadores/listarCamposDisponibles",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crear(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/empresas/crear",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/empresas/editar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/empresas/empresas.service.ts